import * as React from "react";
import { SettingRow, SettingSelect } from "./SettingsWidgets";
// prettier-ignore
var allRanks = [
    '2', '3', '4', '5', '6', '7', '8',
    '9', '10', 'J', 'Q', 'K', 'A', 'NT'
];
var RankSelector = function (props) {
    var _a = React.useState(false), showMetaRank = _a[0], setShowMetaRank = _a[1];
    var handleChange = function (e) {
        if (e.target.value !== "") {
            props.onChangeRank(e.target.value);
        }
    };
    var handleMetaChange = function (e) {
        if (e.target.value !== "") {
            var v = parseInt(e.target.value, 10);
            props.onChangeMetaRank(v);
        }
    };
    var metaranks = [];
    if (props.metaRank > 0) {
        for (var i = 1; i <= props.metaRank + 3; i++) {
            metaranks.push(i);
        }
    }
    else {
        metaranks.push(props.metaRank);
        metaranks.push(1);
    }
    return (React.createElement(SettingRow, { label: "Your rank", hint: "Tick the box to also set a meta-rank.", htmlFor: "rank-selector" },
        React.createElement(SettingSelect, { id: "rank-selector", className: "!min-w-[5rem]", value: props.rank, onChange: handleChange }, allRanks.map(function (rank) { return (React.createElement("option", { value: rank, key: rank }, rank)); })),
        React.createElement("label", { className: "flex cursor-pointer items-center gap-1.5 text-sm text-[var(--text-secondary)]", title: "show meta-rank" },
            React.createElement("input", { type: "checkbox", className: "h-4 w-4 accent-[var(--accent)]", checked: showMetaRank, onChange: function () { return setShowMetaRank(!showMetaRank); } }),
            "meta"),
        showMetaRank && (React.createElement(SettingSelect, { className: "!min-w-[5rem]", value: props.metaRank, onChange: handleMetaChange }, metaranks.map(function (metarank) { return (React.createElement("option", { value: metarank, key: metarank }, metarank)); })))));
};
export default RankSelector;
